<template>
    <form @submit="submit" class="item-editor-form">
        <fg-input v-model="item.dayType.id" :label="$t('day_types.id')" :disabled="action == 'edit'" />
        <fg-input v-model="item.dayType.finnishAbbreviation" :label="$t('day_types.abbreviation')" />
        <fg-input v-model="item.dayType.description" :label="$t('day_types.description')" />

         <label for="organization">{{ $t('day_types.organization') }}</label>
        <OrganizationSelect v-model="item.dayType.organization" id="organization"/>
        
        <hr>

        <label>{{ $t('day_types.weekdays') }}</label>
        <div class="day-type-days">
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.monday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.mon') }}</label>
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.tuesday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.tue') }}</label>
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.wednesday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.wed') }}</label>
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.thursday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.thu') }}</label>
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.friday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.fri') }}</label>
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.saturday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.sat') }}</label>
            <b-form-checkbox value="true" unchecked-value="false" v-model="item.dayType.days.sunday" :disabled="!$UIPrivilege('timetables/daytypes', 'update.weekdays')" />
            <label>{{ $t('weekdays.sun') }}</label>
        </div>

        

<!--
        <label>{{ $t('day_types.exceptions') }}</label>
        <b-row>
            <b-col cols="6">
                <b-form-datepicker v-model="datepick" :locale="locale" start-weekday="1" v-bind="dateTranslations || {}"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
            </b-col>
            <b-col>
                <b-form-group>
                    <b-form-radio v-model="typepick" :value="1">{{ $t('day_types.exception.added') }}</b-form-radio>
                    <b-form-radio v-model="typepick" :value="2">{{ $t('day_types.exception.removed') }}</b-form-radio>
                </b-form-group>
            </b-col>
            <b-col>
                <p-button @click="onAddException" type="default" size="sm" outline class="float-right"><i class="fa fa-plus" style="margin: 0px;"></i></p-button>
            </b-col>
        </b-row>
        <b-table
            small
            striped
            :fields="dayTypeCalendarFields"
            :items="item.dayTypeCalendars"
            thead-class="d-none"
            tbody-tr-class="calendar-list-bodytr">
            <template v-slot:cell(actions)="data">
                <b-icon v-if="$UIPrivilegeUpdate('timetables', 'daytypes')" :title="$t('day_types.remove')"
                    icon="x-circle" variant="danger" style="cursor: pointer;" @click="onRemoveException(data.item.date)" />
            </template>
        </b-table>
        -->
        <DayTypeCalendarEditor v-model="item.dayTypeCalendars" />

        <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeUpdate('timetables', 'daytypes')"  
            :reset="false" 
            :remove="action == 'edit' && $UIPrivilegeDelete('timetables', 'daytypes')" 
            @remove="remove"
            :itemid="item.id"
            :modalid="'DayTypeEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
</template>

<script>
import daytype from '@/store/timetable/daytype';
import DayTypeCalendarEditor from '@/components/Timetable/DayTypeCalendarEditor.vue';
import FormButtons from '@/components/Misc/FormButtons';
import OrganizationSelect from '@/components/Timetable/OrganisationSelect';
//import moment from 'moment';

export default {
    components: {
        DayTypeCalendarEditor, FormButtons, OrganizationSelect
    },
    props: {
        item: {        
            default: function () {
                return {
                    dayType: {
                        id: null
                    },
                    dayTypeCalendars: []
                };
            }
        },
        action: { default: 'new' }
    },
    data: function() {
        return  {
            //datepick: null,
            //typepick: 1,
            ok: false,
            error: false,
            loading: false,
            infoType: 'save'
        }
    },
    beforeCreate() {
        if (!this.$store.state.daytype) {
            this.$store.registerModule('daytype', daytype);
        }
    },
/*    computed: {
        dayTypeCalendarFields() {
            return [
                { key: 'date', label: this.$t('day_types.date'), sortable: false, formatter: this.formatDate },
                { key: 'type', label: this.$t('day_types.type'), sortable: false, formatter: (value) => {
                    return value == 1 ? this.$t('day_types.exception.added') : this.$t('day_types.exception.removed');
                }},
                { key: 'actions', label: this.$t('day_types.actions'), sortable: false }
            ];
        },
        locale() {
            return this.$t('datepicker.locale');
        },
        dateTranslations() {
            return this.$t('datepicker');
        }
    },*/
    methods: {
    /*    onAddException() {
            if (this.datepick != null) {
                var m = moment(this.datepick, 'YYYY-MM-DD');
                if (m.isValid()) {
                    let found = false;
                    for (let dtc of this.item.dayTypeCalendars) {
                        if (dtc.date == this.datepick) {
                            dtc.type = this.typepick;
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        this.item.dayTypeCalendars.push({ date: this.datepick, type: this.typepick, dayTypeId: this.item.dayType.id });
                    }
                }
            }
        },
        onRemoveException(date) {
            let calendars = [];
            for (const c of this.item.dayTypeCalendars) {
                if (c.date != date) {
                    calendars.push(c);
                }
            }
            this.item.dayTypeCalendars = calendars;
        },
        formatDate(date) {
            return new moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
        },*/
        submit(event) {
            if (event)
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = 'save';
            this.loading = true;

            setTimeout(() => {
                this.$store.dispatch(this.action == 'new' ? 'daytype/addDayTypeWithCalendars' : 'daytype/editDayTypeWithCalendars', this.item).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        },
        remove() {
            this.infoType = 'delete';
            this.loading = true;

            setTimeout(() => {
                this.$store.dispatch('daytype/deleteDayType', this.item.dayType.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        }
    }
}
</script>

<style lang="scss">
.day-type-days {
    margin-top: 5px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    label {
        width: 12%;
        font-weight: bold;
    }
}
/*
.calendar-list-headtr {
    visibility: none;
}

.calendar-list-bodytr td {
    font-family: Verdana,Arial,Helvetica,sans-serif;
    font-size: 11px;
    padding: 2px 2px 2px 5px !important;
}*/
</style>